export default "__VITE_ASSET__cda709f5__"